const MuiButton = {
  defaultProps: {
    variant: 'contained',
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      textTransform: 'none',
      fontWeight: 400,
      borderRadius: 4,
    },
  },
};

export default MuiButton;
